import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';

export default class ManageEventLogController extends Controller {
  queryParams = ['page', 'search', 'sort'];

  @tracked page = 1;
  @tracked search = '';
  @tracked sort = 'event_timestamp:desc';

  @action
  changeSearch(search: string): void {
    this.search = search;
    this.page = 1; // Reset to first page
  }

  @action
  changeSort(sort: string): void {
    this.sort = sort;
    this.page = 1; // Reset to first page
  }
}
